/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, names: NonNullable<unknown> }} Artifacts_Download_PartialInputs */



/**
* | output |
* | --- |
* | "{count} could not be exported and are missing from the ZIP: {names}" |
*
* @param {Artifacts_Download_PartialInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const artifacts_download_partial = /** @type {((inputs: Artifacts_Download_PartialInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Artifacts_Download_PartialInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} konnten nicht exportiert werden und fehlen im ZIP: ${i?.names}`)
	return /** @type {LocalizedString} */ (`${i?.count} could not be exported and are missing from the ZIP: ${i?.names}`)
});